export class OrderLine {
	Quantity:number
	UnitPriceExcl:number
	Description:string
	Sku:string
	TotalExcl:number
	TotalIncl:number
	TotalVAT:number
	VATPercentage:number
	ReductionPercentage:number
	ReductionAmount:number
	TaxExempt:boolean
	TaxExemptionReason:string
	IsComment:boolean
	// Additional fields from XML parsing
	LineID: string;
	UnitCode: string;

	public constructor(data:any){
		this.Quantity = data.Quantity || 0.0;
		this.UnitPriceExcl = data.UnitPriceExcl || 0.0;
		this.Description = data.Description || "";
		this.Sku = data.Sku || "";
		this.TotalExcl = data.TotalExcl || 0.0;
		this.TotalIncl = data.TotalIncl || 0.0;
		this.TotalVAT = data.TotalVAT || 0.0;
		this.VATPercentage = data.VATPercentage || 0.0;
		this.ReductionPercentage = data.ReductionPercentage || 0.0;
		this.ReductionAmount = data.ReductionAmount || 0.0;
		this.TaxExempt = data.TaxExempt || false;
		this.TaxExemptionReason = data.TaxExemptionReason || "";
		this.IsComment = data.IsComment || false;
		// Additional fields from XML
		this.LineID = data.LineID || "";
		this.UnitCode = data.UnitCode || "";
	}
}